import DateTimeService from './dateTime';
export const dateTimeService = new DateTimeService();
